import styled from 'styled-components';
import { getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/common';
import { IconWrapper } from '../Icon';
import { getBackgroundColor, getBorderColor, getColor } from './getTagStyles';
import { TagVariant } from './types';

export const MAX_TAG_WIDTH = 200;

export const TagContainer = styled.div<{
    variant?: TagVariant;
    outline?: boolean;
    hasChildren: boolean;
}>`
    background-color: ${(props) => (props.outline ? getToken('backgroundStaticFlat') : getBackgroundColor(props))};
    color: ${(props) => getColor(props)};
    border: ${getToken('borderWidth100')}px solid ${(props) => (props.outline ? getBorderColor(props) : 'transparent')};
    min-width: ${({ theme }) => getToken('sizing300')({ theme }) - getToken('borderWidth100')({ theme }) * 2}px;
    min-height: ${({ theme }) => getToken('sizing300')({ theme }) - getToken('borderWidth100')({ theme }) * 2}px;
    display: inline-flex;
    gap: ${(props) => (props.hasChildren ? getSpacingToken('50') : 0)}px;
    padding: 0 ${({ hasChildren }) => (hasChildren ? getSpacingToken('100') : 0)}px;
    justify-content: center;
    align-items: center;
    border-radius: ${getToken('borderRadius50')}px;
    ${IconWrapper} {
        display: block;
    }
`;

export const TagText = styled.span<{ variant?: TagVariant; outline?: boolean }>`
    max-width: ${MAX_TAG_WIDTH}px;
    ${getTextTokenPreset('bodyMedium')};
    line-height: ${getToken('lineHeight200')};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
